<template>
  <div class="home">
    <!-- 标题栏 -->
    <div class="header">
      <h1>
        <span class="zhejiang">浙江</span>
        <img src="@/assets/land.png" alt="land" class="land-icon" />
        <span class="dayou">大有</span>
      </h1>
    </div>

    <!-- 中间部分：动态模块 -->
    <div class="content">
      <component :is="currentTab.component" />
    </div>

    <!-- 底部Tab栏 -->
    <div class="bottom-tab">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab-item"
        :class="{ active: activeTab === index }"
        @click="switchTab(index)"
      >
        <img :src="activeTab === index ? tab.activeIcon : tab.icon" :alt="tab.name" class="tab-icon" />
        <span class="tab-text">{{ tab.name }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import HomeComponent from '@/components/HomeComponent.vue'; // 首页模块
import UploadComponent from '@/components/UploadComponent.vue'; // 上传模块
import MyComponent from '@/components/MyComponent.vue'; // 我的模块

@Options({
  components: {
    HomeComponent,
    UploadComponent,
    MyComponent,
  },
})
export default class HomeView extends Vue {
  tabs = [
    {
      name: '首页',
      icon: require('@/assets/home.png'), // 默认图标
      activeIcon: require('@/assets/home_active.png'), // 选中时的图标
      component: 'HomeComponent', // 对应的组件
    },
    {
      name: '发布',
      icon: require('@/assets/upload.png'),
      activeIcon: require('@/assets/upload_active.png'),
      component: 'UploadComponent',
    },
    {
      name: '我的',
      icon: require('@/assets/my.png'),
      activeIcon: require('@/assets/my_active.png'),
      component: 'MyComponent',
    },
  ];
  activeTab = 0; // 当前选中的Tab索引

  // 获取当前选中的Tab
  get currentTab() {
    return this.tabs[this.activeTab];
  }

  // 切换Tab
  switchTab(index: number) {
    this.activeTab = index;
  }
}
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f5f5; /* 设置背景色为浅灰色 */
  min-height: 100vh;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; /* 标题栏宽度为 100% */
  background-color: #fff; /* 标题栏背景色 */
  padding: 10px 0; /* 标题栏内边距 */
}

.header h1 {
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #333; /* 默认文字颜色 */
  margin: 0; /* 移除默认的 margin */
}

.land-icon {
  width: 24px; /* 图标大小 */
  height: 24px;
  margin: 0 8px; /* 图标与文字的间距 */
}

.zhejiang {
  font-family: 'Georgia', serif;
  color: #1296db; /* 浙江的颜色 */
}

.dayou {
  font-family: 'Georgia', serif;
  color: #1296db; /* 大有的颜色 */
}

.content {
  flex: 1;
  width: 100%; /* 宽度为 100% */
  background-color: #fff; /* 背景色 */
  margin-top: 0; /* 移除顶部 margin */
  padding-bottom: 60px; /* 添加底部内边距，避免内容被 bottom-tab 遮挡 */
}

.bottom-tab {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  background: white;
  padding: 10px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  height: 60px; /* 设置底部 Tab 栏的高度 */
  z-index: 100; /* 确保 bottom-tab 在最上层 */
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  opacity: 0.6; /* 默认透明度 */
  transition: opacity 0.3s, color 0.3s; /* 添加过渡效果 */
}

.tab-item.active {
  opacity: 1; /* 选中时完全不透明 */
  color: #1296db; /* 选中时文字颜色变为红色 */
}

.tab-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
}

.tab-text {
  font-size: 12px;
  color: inherit; /* 继承父元素的颜色 */
}
</style>